import {getMockupsCompareStats} from "../../thunk/mockupsCompareStats";

export default {
    [getMockupsCompareStats.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [getMockupsCompareStats.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        state.data = action.payload;
        state.queryParams = {...action.meta.arg}
        },
    [getMockupsCompareStats.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    }
}; 